import { Review } from "@shared/lib/types/agency";

import styles from "../styles.module.scss";
import { Avatar, Col, Divider, Modal, Rate, Row, Space } from "antd";
import { Button } from "@shared/ui/Button";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { useRemoveReview } from "@entities/influencer/lib/hooks/useRemoveReview";
import { useAddReview } from "@entities/influencer/lib/hooks/useAddReview";
import { useEffect, useState } from "react";
import { ToastService } from "@shared/lib/services";
import { boolean } from "yup";
import TextArea from "antd/es/input/TextArea";

interface Props {
  reviews: Review[];
  influencerId: string;
}
export function ReviewList({ reviews, influencerId }: Props) {
  const { isRemoved, isRemoving, removeReview } = useRemoveReview();
  const { addReview, isAdded, isAdding } = useAddReview();
  const [deletedReviewId, setdeletedReviewId] = useState<string>("");
  const [reviewModalProps, setReviewModalVisible] = useState<{
    visble: boolean;
    review: number;
    comment: string;
  }>({ visble: false, review: 5, comment: "" });

  const handleDelete = (reviewId: string) => {
    setdeletedReviewId(reviewId);
    removeReview({ influencerId, reviewId });
  };

  useEffect(() => {
    if (isAdded) {
      ToastService.success("Review Added");
      setReviewModalVisible({ visble: false, review: 5, comment: "" });
    }
  }, [isAdded]);
  useEffect(() => {
    if (isRemoved) {
      ToastService.success("Review Deleted");
      setdeletedReviewId("");
    }
  }, [isRemoved]);

  return (
    <div className={styles.card}>
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
          marginBottom: "12px",
        }}>
        <div className={styles.permTitle}>Reviews </div>
        <Button
          variant="outlined"
          size="middle"
          onClick={() =>
            setReviewModalVisible((prev) => ({ ...prev, visble: true }))
          }
          icon={<PlusOutlined />}
          iconPosition="end">
          Add Review
        </Button>
      </Space>

      <Divider style={{ margin: 0, marginBottom: 16 }} />
      {reviews.length ? (
        <div className={styles.permContent}>
          {reviews.map((permItem) => (
            <>
              <PermTile
                review={permItem}
                handleDelete={handleDelete}
                isLoading={isRemoving}
                selectedId={deletedReviewId}
              />
              <Divider style={{ margin: 0 }} />
            </>
          ))}
        </div>
      ) : (
        <div>No Reviews found</div>
      )}
      <Modal
        title="Add Review"
        open={reviewModalProps.visble}
        onCancel={() =>
          setReviewModalVisible({ comment: "", review: 5, visble: false })
        }
        okText="Add"
        onOk={() =>
          addReview({
            influencerId,
            review: {
              comment: reviewModalProps.comment,
              review: reviewModalProps.review,
            },
          })
        }
        okButtonProps={{ loading: isAdding }}
        destroyOnClose>
        <div style={{ padding: 20, display: "grid", gap: 20 }}>
          <Row gutter={[20, 20]}>
            <Col span={4}>Rating :</Col>
            <Col>
              <Rate
                value={reviewModalProps.review}
                onChange={(value) =>
                  setReviewModalVisible((prev) => ({ ...prev, review: value }))
                }
              />
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col span={4}>Review :</Col>
            <Col>
              <TextArea
                value={reviewModalProps.comment}
                onChange={(e) =>
                  setReviewModalVisible((prev) => ({
                    ...prev,
                    comment: e.target.value,
                  }))
                }
                placeholder="Add Review "
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
}

export function PermTile({
  review,
  handleDelete,
  selectedId,
  isLoading,
}: {
  review: Review;
  handleDelete: (reviewId: string) => void;
  selectedId: string;
  isLoading: boolean;
}) {
  return (
    <Row style={{ width: "100%" }} justify={"space-between"} gutter={[20, 20]}>
      <Col span={1}>
        <Avatar src={review.reviewer.profilePicUrl} />
      </Col>
      <Col span={6}>
        <div>
          <div className={styles.permItemTitle}>
            {review.reviewer.firstName} {review.reviewer.lastName}
          </div>
          <Rate disabled value={review.review} style={{ fontSize: "16px" }} />
        </div>
      </Col>
      <Col span={12}>
        <Space style={{ gap: "8px", alignItems: "center" }}>
          <div className={styles.permItemDesc}>{review.comment}</div>
        </Space>
      </Col>

      <Col
        span={2}
        style={{
          justifyContent: "flex-end",
          display: "flex",
          height: "max-content",
        }}>
        <Button
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(review.reviewId)}
          loading={selectedId === review.reviewId && isLoading}></Button>
      </Col>
    </Row>
  );
}
